module.exports = __webpack_public_path__ + "img/prize_description.d6737aca.png";